// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-5931d05e] input::-webkit-outer-spin-button,[data-v-5931d05e] input::-webkit-inner-spin-button {\n  -webkit-appearance: none !important;\n}\n[data-v-5931d05e] input[type=\"number\"] {\n  -moz-appearance: textfield !important;\n}\n", ""]);
// Exports
module.exports = exports;
